<template>
<div class="prefix">
    <span v-if="isRequire" class="require">*</span>
    <span class="title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "test_vue",
  props: {
    isRequire: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  emits: [],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.prefix {
  margin-right: 12px;
  width: 65px;
  height: 20px;
  line-height: 20px;
  text-align: right;
  flex-shrink: 0;

  .require {
    color: #5c70ff;
  }
  .title {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #121317;
    text-align: right;
  }
}
</style>
